<template>
  <div class="h5_person">
      <div v-if="!userInfo">
          <van-empty class="noLogin" :description="$t('other.a1782')" >
          <van-button  type="info" class="bottom-button" @click="toLogin()">{{$t('other.a1765')}}</van-button>
          </van-empty>
      </div>

      <div  v-else>
          <div class="desc_info">
        <div class="pic_box"><img src="../../assets/img/touxiang.png" alt=""></div>
        <div>
            <div>{{name}}</div>
            <div class="id_desc">{{$t('other.a406')}}{{$t('other.a1785')}}:{{id}}</div>
        </div>
    </div>

    <div class="center_wrapper">
        <van-cell-group>
        <van-cell :title="$t('other.a1786')" :value="shopsNum" />
        <van-cell :title="$t('other.a1787')" :value="stores" />
        <van-cell :title="$t('other.a1788')" :value="userIntegral" />
        </van-cell-group>
    </div>


    <div class="center_wrapper"><van-button style="width:100%" @click="signOut()"  type="info">{{$t('other.a1766')}}</van-button></div>
      </div>
  </div>
</template>

<script>
import api from '../../api/api'
import utils from '../../utils/utils'
import jsonp from '../../api/jsonp'

export default {
data(){
  return{
    userName:'123',
    DataList:[],
    userId:null,
    active:2,
    name:'',
    id:'',
    userInfo:null,
    shopsNum:0,
    stores:0,
    userIntegral:0

    
  }
},
created(){
this.init()
 this.getData()
},
methods:{

  init(){
      this.userInfo=JSON.parse(localStorage.getItem('userInfo'))
      this.id=this.userInfo.userId
      this.name=this.userInfo.userName
      this.shopsNum=this.userInfo.lazadaShops.length + this.userInfo.shopeeShops.length
      this.stores=this.userInfo.stores.length
      this.userIntegral=this.userInfo.userIntegral
  },  

  toLogin(){
      this.$router.push({
        path:'/mh5/login',
        query:{
          invitationCode:this.$route.query.invitationCode
        }
      })
  },

  signOut(){
      localStorage.removeItem('userInfo')
      this.$toast(this.$t('other.a1776'))
      this.userInfo=null
  },

  country(id){
    return utils.conutryConversion(id)
  },



  viewDetail(item){
    let userData=JSON.parse(localStorage.getItem('userInfo'))

    if(!userData){
      this.$toast(this.$t('other.a1777'))
      this.$router.push({
        path:'/mh5/login',
        query:{
          invitationCode:$route.query.invitationCode
        }
      })
      return
    }
    this.$router.push({
      path:'/mh5/productDetail',
      query:{
        groupId:item.groupId,
        productId:item.productId,
        invitationCode:$route.query.invitationCode
      }
      
      })
  },

  getData(){

    newOrders
    .getUserInviteeByCode({
      code:this.$route.query.invitationCode
    })
    .then(res => {
    if(res.code === 200 ){
    console.log('desc',res.data)
    this.userName=res.data.userName
    this.userId=res.data.userId
    if(res.data.userId){
        api
        .getPublicStoreItem({
          categoryIds:[],
          name:null,
          offset:50,
          page:0,
          sortType:0,
          userId:res.data.userId
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.DataList=res.data.groups
        }else{
        this.$message.warning(res.msg)
        }
        })
    }

      
    }else{
    this.$message.warning(res.msg)
    }
    })

    
  }

}
}

</script>
<style lang="scss" scoped>

@media (min-width: 1200px)  {
      .h5_mobile{
        background: #409eff;
        height: 100vh;
        font-size: 18px;
      }
}


@media (min-width: 1200px)  {
        .h5_mobile{
        background: #409eff;
        height: 100vh;
        font-size: 18px;



        
      }
}



@media (min-width: 575px) and (max-width: 991px)   {
        .h5_mobile{
        background: #409eff;
        height: 100vh;
        font-size: 18px;
        color: red;
      }





}





@media (max-width: 575px)  {
  html{
    font-size: 25px;
  }

  .h5_person{
      background: #eee;
      min-height: 100vh;


      .noLogin{
          height: 100vh;
      }


      .center_wrapper{
          margin-top: 20px;
      }


      .desc_info{
          display: flex;
          background: #fff;
          box-sizing: border-box;
          padding:10px 0.5rem;

          .pic_box{
              width: 3rem;
              height: 3rem;
              overflow: hidden;
              margin-right: 0.7rem;

              img{
                  width:100%
              }
          }

          .id_desc{
              font-size: 0.7rem;
              padding:10px 0
          }
      }
  }



}





</style>